export default __webpack_public_path__ + "static/media/pethomerTwitter-600x314.865636fd.png";